import { createFileRoute } from '@tanstack/react-router'
import { PipelineRuns } from '@/features/admin/pipeline-runs'

export const Route = createFileRoute(
  '/_authenticated/admin/pipeline-runs'
)({
  component: PipelineRuns,
})
